import isEmpty from 'lodash/isEmpty';

export function formatRules (rules) {
    return rules.map((rule) => formatRule(rule));
}

export function formatRule (rule) {
    const actionConfig = {};

    if (!isEmpty(rule.actionConfig)) {
        Object.keys(rule.actionConfig).forEach((key) => {
            if (!isEmpty(rule.actionConfig[key]) || (key === 'ownedByUserId' && rule.actionConfig[key] !== undefined)) {
                actionConfig[key] = rule.actionConfig[key];
            }
        });
    }

    return {
        ...rule,
        actionConfig,
    };
}
